/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GithubAppInstallationRequestResponse } from '../models/github-app-installation-request-response';
import { GithubAppInstallationRequest } from '../models/github-app-installation-request';
import { OneTimePayloadAwsAccount } from '../models/one-time-payload-aws-account';
import { OneTimePayloadAzureAccount } from '../models/one-time-payload-azure-account';
import { OneTimePayloadBitbucketOauthAppPayload } from '../models/one-time-payload-bitbucket-oauth-app-payload';
import { OneTimePayloadBasicDockerDTO } from '../models/one-time-payload-basic-docker-dto';
import { OneTimePayloadECRArtifactory } from '../models/one-time-payload-ecrartifactory';
import { OneTimePayloadGcpAccount } from '../models/one-time-payload-gcp-account';
import { OneTimePayloadGithubAppInstallationPayload } from '../models/one-time-payload-github-app-installation-payload';
import { OneTimePayloadGitlabOauthAppPayload } from '../models/one-time-payload-gitlab-oauth-app-payload';
import { OneTimePayloadKubernetesAccount } from '../models/one-time-payload-kubernetes-account';
import { CustomOAuth2ClientRegistration } from '../models/custom-oauth-2client-registration';
import { ThemeFileResponse } from '../models/theme-file-response';

/**
 * Public AP Is
 */
@Injectable({
  providedIn: 'root',
})
class PublicApIsService extends __BaseService {
  static readonly getCPCloudUsingGETPath = '/public/v1/cp-cloud';
  static readonly getAllFeaturePropertiesUsingGETPath = '/public/v1/features';
  static readonly getFeaturePropertyUsingGETPath = '/public/v1/features/{name}';
  static readonly processGithubInstallationRequestUsingPOSTPath =
    '/public/v1/github-installation-request';
  static readonly healthCheckUsingGETPath = '/public/v1/health';
  static readonly linkAwsAccountUsingPOSTPath = '/public/v1/link-aws';
  static readonly linkAzureAccountUsingPOSTPath = '/public/v1/link-azure';
  static readonly linkBitbucketAccountUsingPOSTPath =
    '/public/v1/link-bitbucket';
  static readonly linkDockerRegistriesUsingPOSTPath =
    '/public/v1/link-docker-registries';
  static readonly linkECRUsingPOSTPath = '/public/v1/link-ecr';
  static readonly linkGcpAccountUsingPOSTPath = '/public/v1/link-gcp';
  static readonly linkGithubAccountUsingPOSTPath = '/public/v1/link-github';
  static readonly linkGitlabAccountUsingPOSTPath = '/public/v1/link-gitlab';
  static readonly linkK8sAccountUsingPOSTPath = '/public/v1/link-kubernetes';
  static readonly getLoginOptionsUsingGETPath = '/public/v1/loginOptions';
  static readonly getLogoUsingGETPath = '/public/v1/logo';
  static readonly retrieveThemeFileUsingGETPath = '/public/v1/themeFile';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getCPCloud
   * @return OK
   */
  getCPCloudUsingGETResponse(): __Observable<
    __StrictHttpResponse<
      'AWS' | 'AZURE' | 'LOCAL' | 'GCP' | 'KUBERNETES' | 'NO_CLOUD'
    >
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/cp-cloud`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<
          'AWS' | 'AZURE' | 'LOCAL' | 'GCP' | 'KUBERNETES' | 'NO_CLOUD'
        >;
      }),
    );
  }
  /**
   * getCPCloud
   * @return OK
   */
  getCPCloudUsingGET(): __Observable<
    'AWS' | 'AZURE' | 'LOCAL' | 'GCP' | 'KUBERNETES' | 'NO_CLOUD'
  > {
    return this.getCPCloudUsingGETResponse().pipe(
      __map(
        (_r) =>
          _r.body as
            | 'AWS'
            | 'AZURE'
            | 'LOCAL'
            | 'GCP'
            | 'KUBERNETES'
            | 'NO_CLOUD',
      ),
    );
  }

  /**
   * getAllFeatureProperties
   * @return OK
   */
  getAllFeaturePropertiesUsingGETResponse(): __Observable<
    __StrictHttpResponse<{ [key: string]: string }>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/features`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: string }>;
      }),
    );
  }
  /**
   * getAllFeatureProperties
   * @return OK
   */
  getAllFeaturePropertiesUsingGET(): __Observable<{ [key: string]: string }> {
    return this.getAllFeaturePropertiesUsingGETResponse().pipe(
      __map((_r) => _r.body as { [key: string]: string }),
    );
  }

  /**
   * getFeatureProperty
   * @param name name
   * @return OK
   */
  getFeaturePropertyUsingGETResponse(
    name: string,
  ): __Observable<__StrictHttpResponse<{ [key: string]: string }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/features/${encodeURIComponent(String(name))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: string }>;
      }),
    );
  }
  /**
   * getFeatureProperty
   * @param name name
   * @return OK
   */
  getFeaturePropertyUsingGET(
    name: string,
  ): __Observable<{ [key: string]: string }> {
    return this.getFeaturePropertyUsingGETResponse(name).pipe(
      __map((_r) => _r.body as { [key: string]: string }),
    );
  }

  /**
   * processGithubInstallationRequest
   * @param githubAppInstallationRequest githubAppInstallationRequest
   * @return OK
   */
  processGithubInstallationRequestUsingPOSTResponse(
    githubAppInstallationRequest: GithubAppInstallationRequest,
  ): __Observable<__StrictHttpResponse<GithubAppInstallationRequestResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = githubAppInstallationRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/github-installation-request`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GithubAppInstallationRequestResponse>;
      }),
    );
  }
  /**
   * processGithubInstallationRequest
   * @param githubAppInstallationRequest githubAppInstallationRequest
   * @return OK
   */
  processGithubInstallationRequestUsingPOST(
    githubAppInstallationRequest: GithubAppInstallationRequest,
  ): __Observable<GithubAppInstallationRequestResponse> {
    return this.processGithubInstallationRequestUsingPOSTResponse(
      githubAppInstallationRequest,
    ).pipe(__map((_r) => _r.body as GithubAppInstallationRequestResponse));
  }

  /**
   * healthCheck
   * @return OK
   */
  healthCheckUsingGETResponse(): __Observable<
    __StrictHttpResponse<{ [key: string]: {} }>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/health`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: {} }>;
      }),
    );
  }
  /**
   * healthCheck
   * @return OK
   */
  healthCheckUsingGET(): __Observable<{ [key: string]: {} }> {
    return this.healthCheckUsingGETResponse().pipe(
      __map((_r) => _r.body as { [key: string]: {} }),
    );
  }

  /**
   * linkAwsAccount
   * @param payload payload
   */
  linkAwsAccountUsingPOSTResponse(
    payload: OneTimePayloadAwsAccount,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-aws`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkAwsAccount
   * @param payload payload
   */
  linkAwsAccountUsingPOST(
    payload: OneTimePayloadAwsAccount,
  ): __Observable<null> {
    return this.linkAwsAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkAzureAccount
   * @param payload payload
   */
  linkAzureAccountUsingPOSTResponse(
    payload: OneTimePayloadAzureAccount,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-azure`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkAzureAccount
   * @param payload payload
   */
  linkAzureAccountUsingPOST(
    payload: OneTimePayloadAzureAccount,
  ): __Observable<null> {
    return this.linkAzureAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkBitbucketAccount
   * @param payload payload
   */
  linkBitbucketAccountUsingPOSTResponse(
    payload: OneTimePayloadBitbucketOauthAppPayload,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-bitbucket`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkBitbucketAccount
   * @param payload payload
   */
  linkBitbucketAccountUsingPOST(
    payload: OneTimePayloadBitbucketOauthAppPayload,
  ): __Observable<null> {
    return this.linkBitbucketAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkDockerRegistries
   * @param payload payload
   */
  linkDockerRegistriesUsingPOSTResponse(
    payload: OneTimePayloadBasicDockerDTO,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-docker-registries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkDockerRegistries
   * @param payload payload
   */
  linkDockerRegistriesUsingPOST(
    payload: OneTimePayloadBasicDockerDTO,
  ): __Observable<null> {
    return this.linkDockerRegistriesUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkECR
   * @param payload payload
   */
  linkECRUsingPOSTResponse(
    payload: OneTimePayloadECRArtifactory,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-ecr`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkECR
   * @param payload payload
   */
  linkECRUsingPOST(payload: OneTimePayloadECRArtifactory): __Observable<null> {
    return this.linkECRUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkGcpAccount
   * @param payload payload
   */
  linkGcpAccountUsingPOSTResponse(
    payload: OneTimePayloadGcpAccount,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-gcp`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkGcpAccount
   * @param payload payload
   */
  linkGcpAccountUsingPOST(
    payload: OneTimePayloadGcpAccount,
  ): __Observable<null> {
    return this.linkGcpAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkGithubAccount
   * @param payload payload
   */
  linkGithubAccountUsingPOSTResponse(
    payload: OneTimePayloadGithubAppInstallationPayload,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-github`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkGithubAccount
   * @param payload payload
   */
  linkGithubAccountUsingPOST(
    payload: OneTimePayloadGithubAppInstallationPayload,
  ): __Observable<null> {
    return this.linkGithubAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkGitlabAccount
   * @param payload payload
   */
  linkGitlabAccountUsingPOSTResponse(
    payload: OneTimePayloadGitlabOauthAppPayload,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-gitlab`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkGitlabAccount
   * @param payload payload
   */
  linkGitlabAccountUsingPOST(
    payload: OneTimePayloadGitlabOauthAppPayload,
  ): __Observable<null> {
    return this.linkGitlabAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * linkK8sAccount
   * @param payload payload
   */
  linkK8sAccountUsingPOSTResponse(
    payload: OneTimePayloadKubernetesAccount,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/v1/link-kubernetes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * linkK8sAccount
   * @param payload payload
   */
  linkK8sAccountUsingPOST(
    payload: OneTimePayloadKubernetesAccount,
  ): __Observable<null> {
    return this.linkK8sAccountUsingPOSTResponse(payload).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getLoginOptions
   * @return OK
   */
  getLoginOptionsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<CustomOAuth2ClientRegistration>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/loginOptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<
          Array<CustomOAuth2ClientRegistration>
        >;
      }),
    );
  }
  /**
   * getLoginOptions
   * @return OK
   */
  getLoginOptionsUsingGET(): __Observable<
    Array<CustomOAuth2ClientRegistration>
  > {
    return this.getLoginOptionsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<CustomOAuth2ClientRegistration>),
    );
  }

  /**
   * getLogo
   * @return OK
   */
  getLogoUsingGETResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/logo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * getLogo
   * @return OK
   */
  getLogoUsingGET(): __Observable<string> {
    return this.getLogoUsingGETResponse().pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * retrieveThemeFile
   * @return OK
   */
  retrieveThemeFileUsingGETResponse(): __Observable<
    __StrictHttpResponse<ThemeFileResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/public/v1/themeFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ThemeFileResponse>;
      }),
    );
  }
  /**
   * retrieveThemeFile
   * @return OK
   */
  retrieveThemeFileUsingGET(): __Observable<ThemeFileResponse> {
    return this.retrieveThemeFileUsingGETResponse().pipe(
      __map((_r) => _r.body as ThemeFileResponse),
    );
  }
}

module PublicApIsService {}

export { PublicApIsService };
